export default "__VITE_ASSET__BiIHilsx__"